@if (isVisible) {
<div class="notification toast" [ngClass]="[ animationClass]">
  <button class="delete m-auto" (click)="close()"></button>
  <span class="icon-text">
    <fa-stack [ngClass]="'is-'+toastType">
      <fa-icon [icon]="faCircle" stackItemSize="2x"></fa-icon>
      <fa-icon [icon]="toastIcon" [inverse]="true" stackItemSize="1x"></fa-icon>
    </fa-stack>
    <span class="m-auto">{{ message | translate }}</span>
  </span>
</div>
}
